var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6C8 7.10461 7.10449 8 6 8C4.89551 8 4 7.10461 4 6C4 4.89539 4.89551 4 6 4C7.10449 4 8 4.89539 8 6Z",
    fill: "#647B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14C7.10449 14 8 13.1046 8 12C8 10.8954 7.10449 10 6 10C4.89551 10 4 10.8954 4 12C4 13.1046 4.89551 14 6 14Z",
    fill: "#647B8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18C8 19.1046 7.10449 20 6 20C4.89551 20 4 19.1046 4 18C4 16.8954 4.89551 16 6 16C7.10449 16 8 16.8954 8 18Z",
    fill: "#647B8F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6C14 7.10461 13.1045 8 12 8C10.8955 8 10 7.10461 10 6C10 4.89539 10.8955 4 12 4C13.1045 4 14 4.89539 14 6Z",
    fill: "#647B8F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C13.1045 14 14 13.1046 14 12C14 10.8954 13.1045 10 12 10C10.8955 10 10 10.8954 10 12C10 13.1046 10.8955 14 12 14Z",
    fill: "#647B8F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18C14 19.1046 13.1045 20 12 20C10.8955 20 10 19.1046 10 18C10 16.8954 10.8955 16 12 16C13.1045 16 14 16.8954 14 18Z",
    fill: "#647B8F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6C20 7.10461 19.1045 8 18 8C16.8955 8 16 7.10461 16 6C16 4.89539 16.8955 4 18 4C19.1045 4 20 4.89539 20 6Z",
    fill: "#647B8F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14C19.1045 14 20 13.1046 20 12C20 10.8954 19.1045 10 18 10C16.8955 10 16 10.8954 16 12C16 13.1046 16.8955 14 18 14Z",
    fill: "#647B8F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18C20 19.1046 19.1045 20 18 20C16.8955 20 16 19.1046 16 18C16 16.8954 16.8955 16 18 16C19.1045 16 20 16.8954 20 18Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/details.86dbf79e.svg";
export { ForwardRef as ReactComponent };